import Textarea from "./FieldTextarea";
import { withErrorMessage } from "../withErrorMessage";

export const FieldTextarea = withErrorMessage(Textarea);

export default FieldTextarea;
